(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-gift-card"] && !Shopify.designMode) return;
  try {
    
  /* Ardent Héritage — la carte cadeau sort de son enveloppe au défilement.
     La position dans la page pilote le mouvement : descendre la fait sortir,
     remonter la fait rentrer. Aucun mouvement si le visiteur les limite. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { return; }

    var packs = [];
    var ticking = false;

    function collect() {
      packs = Array.prototype.slice.call(document.querySelectorAll('[data-ah-gc-pack]'));
      if (packs.length) { measure(); }
    }

    function measure() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < packs.length; i++) {
        var pack = packs[i];
        var box = pack.getBoundingClientRect();

        /* 0 quand le haut de l'enveloppe touche le bas de l'écran,
           1 quand elle est presque en haut : plus la course est longue,
           plus la carte sort lentement. */
        var travel = Math.max(1, vh * 0.9);
        var progress = (vh - box.top) / travel;
        if (progress < 0) { progress = 0; }
        if (progress > 1) { progress = 1; }
        pack.style.setProperty('--ah-gc-out', progress.toFixed(3));
      }
      ticking = false;
    }

    function onScroll() {
      if (ticking || !packs.length) { return; }
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', collect);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Délégation au niveau du document : fonctionne pour toutes les sections
       d'avis de la page, y compris celles rechargées par l'éditeur de thème. */
    function items(dialog) {
      var section = dialog.closest('section') || document;
      var list = Array.prototype.slice.call(section.querySelectorAll('[data-ah-rv-item]'));
      list.sort(function (a, b) { return Number(a.dataset.index) - Number(b.dataset.index); });
      return list;
    }

    function show(dialog, index) {
      var list = items(dialog);
      if (!list.length) return;
      var i = (index + list.length) % list.length;
      var el = list[i];
      var img = dialog.querySelector('.ah-rv-dialog__img');
      img.src = el.dataset.src;
      if (el.dataset.w && el.dataset.h) {
        img.width = Number(el.dataset.w);
        img.height = Number(el.dataset.h);
      }
      img.alt = 'Photo de ' + (el.dataset.caption || 'client');
      dialog.querySelector('[data-ah-rv-caption]').textContent = el.dataset.caption || '';
      var counter = dialog.querySelector('[data-ah-rv-counter]');
      counter.textContent = list.length > 1 ? (i + 1) + ' / ' + list.length : '';
      dialog.dataset.current = String(i);
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ah-rv-open]');
      if (opener) {
        var dialog = document.getElementById(opener.dataset.ahRvOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog._ahReturn = opener;
        show(dialog, Number(opener.dataset.index) || 0);
        dialog.showModal();
        return;
      }

      var dlg = e.target.closest('.ah-rv-dialog');
      if (!dlg) return;

      var step = e.target.closest('[data-ah-rv-step]');
      if (step) {
        show(dlg, Number(dlg.dataset.current || 0) + Number(step.dataset.ahRvStep));
        return;
      }
      /* Fermeture : bouton, ou clic en dehors de l'image et des contrôles. */
      if (e.target.closest('[data-ah-rv-close]') || !e.target.closest('.ah-rv-dialog__img, .ah-rv-dialog__caption, .ah-rv-dialog__btn')) {
        closeViewer(dlg);
      }
    });

    /* Nettoyage appelé directement par chaque voie de fermeture : l'événement
       « close » du dialog n'est pas émis de façon fiable par tous les
       navigateurs, on ne peut donc pas s'en remettre à lui seul. */
    function tidy(dlg) {
      var img = dlg.querySelector('.ah-rv-dialog__img');
      if (img) img.removeAttribute('src');
      var back = dlg._ahReturn;
      dlg._ahReturn = null;
      if (back && document.contains(back)) back.focus();
    }

    function closeViewer(dlg) {
      if (dlg.open) dlg.close();
      tidy(dlg);
    }

    document.addEventListener('keydown', function (e) {
      var dlg = document.querySelector('.ah-rv-dialog[open]');
      if (!dlg) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(dlg, Number(dlg.dataset.current || 0) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(dlg, Number(dlg.dataset.current || 0) - 1); }
      if (e.key === 'Escape') { e.preventDefault(); closeViewer(dlg); }
    });

    /* Filet de sécurité pour une fermeture venue d'ailleurs (navigateur,
       extension) : sans effet si closeViewer est déjà passé. */
    document.addEventListener('close', function (e) {
      var dlg = e.target;
      if (!dlg.classList || !dlg.classList.contains('ah-rv-dialog')) return;
      if (dlg._ahReturn) tidy(dlg);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
